import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar, Box, CssBaseline, Drawer, Hidden, IconButton, Toolbar } from '@mui/material';
import { FC, Fragment, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

//components
import { LogoIcon } from 'assets/svgs';
import Sidebar from 'components/Layouts/Sidebar';
import DemoAlert from './DemoAlert';
import UserProfilePopover from 'components/main/Dashboard/UserAvatarPopover';

//constants, theme, context, helpers, styles
import { DASHBOARD_ROUTE } from 'constants/index';
import { DrawerContext, DrawerContextProvider } from 'contexts/DrawerContext';
import { MainLayoutProps } from 'interfaces';
import { cursorPointer } from 'styles/commonComponentStyle';
import { DrawerContentBox } from 'theme/styleComponent';
import {
  appBarFixedStyles,
  drawerContentBoxStyled,
  drawerKeepMounted,
  drawerOpenButton,
  drawerPermanent,
  navComponent,
  toolbarIconButton,
} from 'styles/DrawerSidebarStyle';

const CustomDrawer: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Toolbar sx={{ paddingY: 4, paddingX: '40px !important' }}>
        <Box onClick={() => navigate(DASHBOARD_ROUTE)}>
          <LogoIcon />
        </Box>
      </Toolbar>

      <Box paddingX="20px">
        <Box minHeight="calc(100vh - 282px)">
          <Sidebar />
        </Box>
      </Box>

      <Box paddingX="20px">
        <UserProfilePopover />
      </Box>
    </Fragment>
  );
};

const Layout: FC<MainLayoutProps> = (props) => {
  const navigate = useNavigate();
  const { window, children } = props;
  const { mobileOpen, setMobileOpen } = useContext(DrawerContext);

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box display="flex">
      <CssBaseline />
      <AppBar position="fixed" sx={appBarFixedStyles}>
        <Toolbar sx={toolbarIconButton}>
          <Hidden only={['lg', 'xl']}>
            <Box flex="1" sx={cursorPointer} onClick={() => navigate(DASHBOARD_ROUTE)}>
              <LogoIcon height={50} width={125} />
            </Box>
          </Hidden>

          <IconButton
            edge="start"
            id="menu-icon-btn-id"
            onClick={() => setMobileOpen(true)}
            sx={drawerOpenButton}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box component="nav" sx={navComponent}>
        <Hidden only={['lg', 'xl']}>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            sx={drawerKeepMounted}>
            <CustomDrawer />
          </Drawer>
        </Hidden>

        <Hidden only={['xs', 'sm', 'md']}>
          <Drawer variant="permanent" sx={drawerPermanent} open>
            <CustomDrawer />
          </Drawer>
        </Hidden>
      </Box>
      <DrawerContentBox component="main" sx={drawerContentBoxStyled}>
        <DemoAlert />
        {children}
      </DrawerContentBox>
    </Box>
  );
};

const MainLayout: FC<MainLayoutProps> = (props) => {
  return (
    <DrawerContextProvider>
      <Layout {...props} />
    </DrawerContextProvider>
  );
};

export default MainLayout;
